import React from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as PlayIcon } from "../assets/icon_play.svg";
import { ReactComponent as StopIcon } from "../assets/icon_stop.svg";
import styles from "../styles/RecordingTaskFeedbackStyles";

const RecordingTaskFeedback = ({
  task,
  onPlay = () => {},
  onStop = () => {},
}) => {
  const navigate = useNavigate();

  const handleTaskClick = () => {
    if (task.usedAsNote) {
      navigate(`/noteDetail/${task.id}`);
    } else {
      navigate(`/taskDetail/${task.id}`);
    }
  };

  const handleClick = (e) => {
    e.stopPropagation();
    if (task.taskBeingTracked) {
      onStop();
    } else {
      onPlay();
    }
  };

  return (
    <div style={styles.container} onClick={handleTaskClick}>
      <button onClick={handleClick} style={styles.iconButton}>
        {task.taskBeingTracked ? (
          <StopIcon style={styles.icon} />
        ) : (
          <PlayIcon style={styles.icon} />
        )}
      </button>
      <div style={styles.title}>{task.title || "Unnamed Task"}</div>
    </div>
  );
};

export default RecordingTaskFeedback;